var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "#555555",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67464 5.94519C4.67464 3.91841 6.30738 2.28571 8.30876 2.28571C10.3101 2.28571 11.9429 3.91841 11.9429 5.94519C11.9429 7.97198 10.3101 9.60467 8.30876 9.60467C6.30738 9.60467 4.67464 7.97198 4.67464 5.94519ZM8.30876 0C5.03363 0 2.38892 2.66746 2.38892 5.94519C2.38892 9.22292 5.03363 11.8904 8.30876 11.8904C11.5839 11.8904 14.2286 9.22292 14.2286 5.94519C14.2286 2.66746 11.5839 0 8.30876 0ZM3.35232 17.7626C4.03433 17.0768 4.95801 16.6927 5.91983 16.6927H10.6968C11.6586 16.6927 12.5823 17.0768 13.2643 17.7626C13.9465 18.4485 14.3309 19.3801 14.3309 20.3529V22.7544C14.3309 23.3856 14.8426 23.8972 15.4738 23.8972C16.105 23.8972 16.6166 23.3856 16.6166 22.7544V20.3529C16.6166 18.7779 15.9944 17.2662 14.8849 16.1507C13.7752 15.035 12.2688 14.407 10.6968 14.407H5.91983C4.34778 14.407 2.84138 15.035 1.73168 16.1507C0.622193 17.2662 0 18.7779 0 20.3529V22.7544C0 23.3856 0.511675 23.8972 1.14286 23.8972C1.77404 23.8972 2.28571 23.3856 2.28571 22.7544V20.3529C2.28571 19.3801 2.67009 18.4485 3.35232 17.7626Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4a24e397.svg";
export { ForwardRef as ReactComponent };